import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.46 2.18a3.78 3.78 0 1 0 0 7.56 3.78 3.78 0 0 0 0-7.56M.6 5.96a4.86 4.86 0 1 1 9.72 0 4.86 4.86 0 0 1-9.72 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.129 8.63a.54.54 0 0 1 .763 0l2.35 2.348a.54.54 0 1 1-.764.764l-2.35-2.35a.54.54 0 0 1 0-.763",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".5",
      d: "M5.46 2.18a3.78 3.78 0 1 0 0 7.56 3.78 3.78 0 0 0 0-7.56M.6 5.96a4.86 4.86 0 1 1 9.72 0 4.86 4.86 0 0 1-9.72 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".5",
      d: "M8.129 8.63a.54.54 0 0 1 .763 0l2.35 2.348a.54.54 0 1 1-.764.764l-2.35-2.35a.54.54 0 0 1 0-.763",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }